module.exports = __webpack_public_path__ + "img/icon.ab604db3.png";